import { FC } from "react";
import { Button, Stack, Text } from "@chakra-ui/react";

interface Props {
  onClose: () => void;
}

export const ForeignPassportInfoModal: FC<Props> = ({ onClose }) => {
  return (
    <Stack pt="12px" alignItems="center">
      <Text fontSize="20px" mb="2px" variant="brand" fontFamily="Normalidad Medium Var">
        Иностранный паспорт
      </Text>

      <Text fontSize="14px" textAlign="center">
        Выберите этот пункт, если у вас загранпаспорт или гражданский паспорт другой страны — не паспорт РФ.
      </Text>

      <Button onClick={onClose} mt="8px" w="100%">
        Понятно
      </Button>
    </Stack>
  );
};
